
function Profile() {
    return (
        <div class="page-content">
           hello
        </div>
    );
}

export default Profile;
